<template>
    <section class="data-page">
        <div class="row  justify-content-center mt-5 mt-5" >
          <div class="col-sm-12">
             <form v-on:submit.prevent="Confirm()"   class="">
            <div   class="form-content p-4">
                            <p class="text-center">Select the type of airtime to purchase.Different rates apply.</p>
              <ul class="nav nav-pills modern-tabs justify-content-center mb-4" id="bambaTabs" role="tablist">

  <li class="nav-item" role="presentation" v-on:click="routerPage('purchase')" v-if="message.airtime_type=='discounted'">
    <button class="nav-link "
            id="bambaPlus-tab"
            data-bs-toggle="pill"
            data-bs-target="#bambaPlus"
            type="button"
            role="tab">
      Bamba++
    </button>
  </li>

  <li class="nav-item " role="presentation" v-on:click="routerPage('purchase.pinless')" v-else>
    <button class="nav-link"
            id="bamba-tab"
            data-bs-toggle="pill"
            data-bs-target="#bamba"
            type="button"
            role="tab">
     Bamba
    </button>
  </li>
    <li class="nav-item " role="presentation" v-on:click="routerPage('airtel')" >
    <button class="nav-link active"
            id="bamba-tab"
            data-bs-toggle="pill"
            data-bs-target="#bamba"
            type="button"
            role="tab">
     <span class="text-danger">Airtel</span>
    </button>
  </li>

</ul>
                <h6 class="text-center mb-2">Buy <span class="text-danger">Airtel</span> Airtime at <b>{{message.discount}}% </b> less</h6>


              <div class="row justify-content-center">
                <div class="col-sm-12">

              <div class="form-group mb-2">
                <label>Mpesa Phone no.<span class="text-danger">*</span></label>
               <div class="d-flex">
                <input type="text" class="form-input" v-on:keyup="setValues()" v-model="message.phone" :disabled="isDisabled" required >
                 <a v-on:click="changePhone()"><i class="fa fa-edit text-success fa-2x"></i></a>
                 </div>
              </div>
               <div class="form-group mb-2">
                <label>Number to buy for.<span class="text-danger">*</span></label>
                <input type="text" class="form-input"  v-model="message.account"  required>
              </div>
               <div class="form-group mb-2">
                <label>Amount of airtime.<span class="text-danger">*</span></label>
                <input type="text" class="form-input" v-on:keyup="calculatePrice()" v-model="message.credit"  required>
              </div>
             <p class=" text-center mt-1 mb-1">Amount you will pay: <b>Ksh.{{formatPrice(message.amount)}}</b></p>

                    <div class="form-group">
                                        <div class="container mt-1" v-if="showAlert==='true'">
                                    <p class="text-primary text-center">Please enter m-pesa pin to proceed...</p>

                            </div>
                            <div class="container mt-1" v-if="showAlert==='success'">

                                    <h6 class="text-success text-center">{{message.mpesa_ref}}</h6>
                                    <p class="text-center text-success">Payment successful,please wait we redirect you...</p>
                            </div>
                            <div class="container mt-1" v-if="showAlert==='error'">

                                    <p class="text-danger text-center">User cancelled!,please wait we redirect you...</p>
                            </div>
                                    </div>
              <div class="text-center"><button  type="submit" class="btn btn-success btn-block btn-airtel" :disabled="loading">
                <span v-if="!loading">
                 Buy Now  <i class="fa fa-arrow-right ms-1"></i>
              </span>
              <span v-else class="spinner-border spinner-border-sm text-light" role="status"></span>
            </button></div>

          <!-- <p class="mt-3 text-center "><b>Airtimes Available → {{ formatPrice(airtel_balance.rate) }}</b></p> -->

              </div>
              <div class="container text-center mt-5">
    <a href="https://play.google.com/store/apps/details?id=io.ionic.airtimetocash" target="_blank">
        <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="Get it on Google Play"
            style="width:100px;height:auto;opacity: 0.7;">
    </a>
</div>
              </div>
              </div>
                </form>
          </div>
        </div>
</section>
</template>
<script>
    // import moment from 'moment'
    export default {
        name: 'Index',
        components: {

        },
        data(){
            return {
                message:{discount:'0',discount2:'0',credit:'',buy_for:'other',amount:'',source:'web-portal',airtime_type:'normal',account:'',phone:'',telco:'AIRTEL'},
                role:'false',
                phone:'',
                loading: false,
                 showAlert:'false',
                  denominations:[],
                  airtel_balance:{rate:'0'},
                   isDisabled: false,

            }
        },
        created(){
          this.getUser();
          this.getIp();
              this.getDiscount();
        },
        methods: {
              getIp(){
                let uri =`https://api.ipify.org/?format=json`;
                this.$axios.get(uri).then((response) => {
                  this.message.ip_address=response.data.ip;
                  this.message.os=window.navigator.platform;
                }).catch(error => {

                });
          },
            submitTest() {
      this.loading = true;
      // simulate request (replace with your API call)
      setTimeout(() => {
        this.loading = false;
        this.$swal({icon: 'warning',title: 'Error',text: 'We are not able to complete your request.'});
      }, 8000);
    },
    Confirm() {
  Swal.fire({
    title: 'You are about to Send Airtime of Ksh .'+this.message.credit+' to '+this.message.account,
    text: 'Payment request will be initiated for processing',
    // icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Proceed and buy!',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#41AA28',
    cancelButtonColor: '#ff7674',
    reverseButtons: true,
    customClass: {
      title: 'swal-small-title'
    }
  }).then((result) => {
    if (result.isConfirmed) {
      this.initiateSTK();
    }
  })
},
            initiateSTK(){
           this.loading = true;
            let uri =`/api/auth/initiateSTKspacepay`;
            this.$axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
               this.loading = false;
                if(response.data.status){
                    this.showAlert='true';
                    this.message.id=response.data.id;
                    localStorage.setItem('count',0);
                    this.interval = setInterval(() => this.checkSTKStatus(), 5000);
                }else{
                  this.loading = false;
                 if (error.response.status === 401) {
                    this.$router.push({name: 'auth'});
                     localStorage.removeItem('token');
                     localStorage.removeItem('auth');
                }else{
                this.$swal({icon: 'warning',title: 'Error',text: 'We are not able to complete your request.'});
                }

                }
            }).catch(error => {
                this.loading = false;
                this.$swal({icon: 'warning',title: 'Error',text: 'We are not able to complete your request.'});
            });
          },
          checkSTKStatus(){
            let uri =`/api/auth/checkSTKStatus`;
            this.$axios.post(uri,this.message,{ headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
               if(response.data.status){
                    if(response.data.callback){
                        this.message.mpesa_ref=response.data.mpesa_ref;
                        this.showAlert='success';
                        clearInterval(this.interval)
                        setTimeout(() => {
                        location.reload();
                              }, 5000);
                    }else{
                      clearInterval(this.interval);
                        this.showAlert='error';
                        setTimeout(() => {
                             location.reload();
                              }, 5000);
                    }
                }
            }).catch(error => {
              clearInterval(this.interval)
              this.interval = setInterval(() => this.checkSTKStatus(), 5000);
            });
        },

            getDiscount(){
                let uri =`/api/auth/discount`;
                this.$axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                   this.message.discount=response.data.airtel_rate.rate;
                  //  this.airtel_balance=response.data.airtel_balance;
                   this.message.airtime_type=response.data.priority_tab.rate;
                }).catch(warning => {

                });
            },
             routerPage(val){
             this.$router.push({name: val});
            },
              setValues(){
            this.message.account=this.message.phone;
            },
          calculatePrice(){
            var percentage=(+this.message.discount * +this.message.credit)/100;
           this.message.amount=Math.round(+this.message.credit-percentage);
          },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
                        getUser(){
            let uri =`/api/auth/getUser`;
           this.$axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                this.message.phone=response.data.phone;
                 this.isDisabled=true;
            }).catch(error => {
                    if (error.response.status === 401) {

                }else{

                }
            });
},
changePhone(){
  this.$router.push({name: 'auth'});
}
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/airtel.vue